import { api } from "../_services";
import { userActions } from "../_actions";

/* globals process */
export const userService = {
  login,
  logout,
  getAuthenticatedUser
};

function login(username, password) {
  const ClientOAuth2 = require("client-oauth2");
  const auth = new ClientOAuth2({
    clientId: process.env.REACT_APP_CLIENT_ID,
    clientSecret: process.env.REACT_APP_SECRET,
    accessTokenUri: process.env.REACT_APP_API_HOST + "/api/o/token/",
    scopes: ["read", "write"]
  });

  const promise1 = auth.owner
    .getToken(username, password)
    .then(function(result) {
      if (result.accessToken) {
        const user = {
          username: username,
          token: result.accessToken,
          // add expire to token
          expiresAt: result.expires
        };

        localStorage.setItem("user", JSON.stringify(user));
        return user;
      }
    })
    .catch(error => {
      console.log(error.message);
      return "Username or password is incorrect";
    });

  return promise1;
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("user");
}

function getAuthenticatedUser(token) {
  return dispatch => {
    const url = "/api/v1/authenticated_user/";
    const params = {};
    const errorMsg = "Unable to retrieve authenticated user's details.";
    return api.getFetch(url, params, token, errorMsg).then(({ display_name, email, email_md5 }) => {
      const userData = { display_name, email, email_md5 };
      dispatch(userActions.getAuthenticatedUserData(userData));
      return {
        display_name,
        email,
        email_md5
      };
    });
  };
}



// WEBPACK FOOTER //
// ./src/_services/user.service.js